import { useEffect, useState } from "react";
import { API } from "../../http-common";
import "../../assets/css/admin_users_page.css";
import "../../assets/css/audit_log_users_page.css";
import Header from "./includes_admin/Header";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  formatAuditDate,
  getAuditActionLabel,
  getAuditPerformedBy,
  getAuditAffectedUser,
} from "../../helpers/auditLogs";
import { ModalAuditLog } from "./Modal/ModalAuditLog";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export const AuditLogsUsersPage = () => {
  const [logs, setLogs] = useState([]);
  const [limit, setLimit] = useState(20);
  const [loading, setLoading] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const history = useHistory();

  const goBack = () => {
    history.push("/admin/users");
  };

  const fetchLogs = async (selectedLimit) => {
    try {
      setLoading(true);
      const response = await API.get(`/user/audit-logs?limit=${selectedLimit}`);
      setLogs(response?.data?.data || []);
    } catch (error) {
      console.log(error);
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(limit);
  }, [limit]);

  return (
    <div className="container-fluid" id="applicant_container_fluid">
      <div className="row mb-4">
        <Header hideBusinessBadge />
      </div>

      <div className="audit_logs_page">
        <div className="audit_logs_top_actions">
          <Button
            size="md"
            onClick={goBack}
            className="users_back_btn btn-warning"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{ fontSize: 16, color: "black" }}
              className="me-2"
            />
            Volver a usuarios
          </Button>
        </div>

        <div className="audit_logs_banner">
          <div className="audit_logs_header">
            <span className="audit_logs_title">Registro de cambios</span>

            <div className="audit_logs_actions">
              <label htmlFor="audit-limit">Mostrar:</label>
              <select
                id="audit-limit"
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
              >
                <option value={20}>Últimos 20</option>
                <option value={50}>Últimos 50</option>
              </select>
            </div>
          </div>
        </div>

        <div className="audit_logs_container">
          <div className="table-wrapper">
            <div className="table-responsive">
              {loading ? (
                <p>Cargando registros...</p>
              ) : logs.length === 0 ? (
                <p>No hay registros para mostrar.</p>
              ) : (
                <table className="audit_logs_table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Acción</th>
                      <th>Realizado por</th>
                      <th>Usuario afectado</th>
                      <th style={{ textAlign: "right" }}>Detalle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log) => (
                      <tr key={log.id}>
                        <td>{formatAuditDate(log.created_at)}</td>
                        <td>{getAuditActionLabel(log.action)}</td>
                        <td>{getAuditPerformedBy(log)}</td>
                        <td>{getAuditAffectedUser(log)}</td>
                        <td style={{ textAlign: "right" }}>
                          <button
                            type="button"
                            className="audit_logs_detail_btn"
                            onClick={() => setSelectedLog(log)}
                          >
                            Ver detalle
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>

        <ModalAuditLog
          log={selectedLog}
          onClose={() => setSelectedLog(null)}
        />
      </div>
    </div>
  );
};